import {hostByBrandByEnv} from '../../../../../hosts'
import {CSP} from '../../../../constants'
import {createPreset} from '../../../../utils'

export const YA_AUTHPROXY = createPreset(
  [CSP.IMG, CSP.CONNECT],
  [hostByBrandByEnv.yandex.testing.yaAuthProxy.authorized],
)
